import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TermsAcceptance, TermsStatus } from '../../models/terms-acceptance';

/** The signed-in User's acceptance of the Terms and Conditions (Agreement). */
@Injectable({
  providedIn: 'root',
})
export class TermsAcceptanceApiService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private url = `${environment.api.replace(/\/$/, '')}/terms/acceptance`;

  status(): Observable<TermsStatus> {
    return this.auth.token$.pipe(
      take(1),
      switchMap((token) =>
        this.http.get<TermsStatus>(this.url, {
          headers: this.authHeader(token),
        })
      )
    );
  }

  accept(version: string): Observable<TermsAcceptance> {
    return this.auth.token$.pipe(
      take(1),
      switchMap((token) =>
        this.http.post<TermsAcceptance>(
          this.url,
          { version },
          { headers: this.authHeader(token) }
        )
      )
    );
  }

  private authHeader(token?: string): HttpHeaders | undefined {
    return token
      ? new HttpHeaders({ Authorization: `Bearer ${token}` })
      : undefined;
  }
}
